export const Peticion = async (
  url,
  metodo,
  datosGuardar = "",
  archivos = false
) => {
  let cargando = true;

  let opciones = {
    method: "GET",
  };

  if (metodo === "GET" || metodo === "DELETE") {
    opciones = {
      method: metodo,
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
      },
    };
  }

  if (metodo === "POST" || metodo === "PUT") {
    // let body = "";

    if (archivos) {
      opciones = {
        method: metodo,
        body: datosGuardar,
      };
    } else {
      opciones = {
        method: metodo,
        body: JSON.stringify(datosGuardar),
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          // "Access-Control-Allow-Origin": '*',
          // "Access-Control-Allow-Methods": "POST, GET, OPTIONS, DELETE"
        },
      };
    }
  }

  const peticion = await fetch(url, opciones);
  const datos = await peticion.json();

  // console.log(datos);

  cargando = false;

  return {
    datos,
    cargando,
  };
};
